export interface SumUpFinalize {
    taskID: string;
    totalAmountFromPayment: number;
}
